// extracted by mini-css-extract-plugin
export default {"item":"FilePreviews_item__31U4W","icon":"FilePreviews_icon__-Bs5f","label":"FilePreviews_label__dE2Tx"};